import { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import LocalStorageService from '~/utils/localStorageService';
import { NAVIGATION_VIEW_STATE_KEY, TRANSITION_DURATION_MS } from '../constants';
// import { NavRouteStaticDataType } from '../types';
import { NAVIGATION_VIEW_STATES } from '../types/enums';
import useAutoCollapse from './useAutoCollapse';
// @ts-ignore
import { useSidebarContext } from '@mindtickle/ui-shell-core/Sidebar';

const localStorageService = new LocalStorageService();

const useNavigationData = () => {
  const { pathname } = useLocation();
  const { navConfig, navConfigError } = useSidebarContext();

  const navigationViewState =
    localStorageService.getData(NAVIGATION_VIEW_STATE_KEY).data ?? NAVIGATION_VIEW_STATES.EXPANDED;

  const [isCollapsed, setIsCollapsed] = useState(
    navigationViewState !== NAVIGATION_VIEW_STATES.EXPANDED
  );
  const [transitionInProgress, setTransitionInProgress] = useState(false);

  const { autoCollapse } = useAutoCollapse({ pathname });

  const toggleNavigation = useCallback(() => {
    if (autoCollapse) {
      setIsCollapsed(!isCollapsed);
      localStorageService.setData(
        NAVIGATION_VIEW_STATE_KEY,
        isCollapsed ? NAVIGATION_VIEW_STATES.EXPANDED : NAVIGATION_VIEW_STATES.COLLAPSED
      );
      return;
    }

    if (!transitionInProgress) {
      if (!isCollapsed) {
        setTransitionInProgress(true);
        const timerId = setTimeout(() => {
          setIsCollapsed(true);
          localStorageService.setData(NAVIGATION_VIEW_STATE_KEY, NAVIGATION_VIEW_STATES.COLLAPSED);
          setTransitionInProgress(false);
          clearTimeout(timerId);
        }, TRANSITION_DURATION_MS);
      } else {
        setIsCollapsed(false);
        localStorageService.setData(NAVIGATION_VIEW_STATE_KEY, NAVIGATION_VIEW_STATES.EXPANDED);
      }
    }
  }, [autoCollapse, isCollapsed, transitionInProgress]);

  const onTransitionEnd = useCallback(() => {
    setTransitionInProgress(false);
  }, []);

  return {
    isCollapsed: autoCollapse || isCollapsed,
    transitionInProgress,
    navConfig,
    navConfigError,
    toggleNavigation,
    onTransitionEnd,
    autoCollapse,
  };
};

export default useNavigationData;
